import { BreakpointsOptions } from '@mui/material'

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 540,
    md: 768,
    lg: 1048,
    xl: 1440,
  },
}

export default breakpoints
